import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { LocalStorageUtils } from "../helpers/LocalStorage";
import {
  DataDBType,
  ResponseTypeIndustriesDB,
  CertificateType,
  EducationType,
  ExperienceType,
} from "../interfaces/user";
import { RootState } from "./store";
import { BASE_URL } from "../constants/stringConstants";

export const profileApi = createApi({
  reducerPath: "profile",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set("Accept", "application/json");
      const token = LocalStorageUtils.getItem("auth_token");
      if (token && endpoint !== "/auth/login" && endpoint !== "/auth/signup") {
        headers.set("Authorization", `Bearer ${JSON.parse(token)}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getProfileDataFromDB: builder.mutation<
      ResponseTypeIndustriesDB,
      DataDBType
    >({
      query: ({ param, filterDetails }) => ({
        url: `candidate/${param}?filter=${filterDetails}`,
        method: "GET",
      }),
    }),

    addCertificate: builder.mutation<ResponseTypeIndustriesDB, CertificateType>(
      {
        query: ({ param, data }) => ({
          url: `candidates/${param}/candidate-certificates`,
          method: "POST",
          body: data,
        }),
      }
    ),

    editCertificate: builder.mutation<
      ResponseTypeIndustriesDB,
      CertificateType
    >({
      query: ({ param, data }) => ({
        url: `candidateCertificate/${param}`,
        method: "PATCH",
        body: data,
      }),
    }),

    getEducations: builder.mutation<any, any>({
      query: () => ({
        url: `educations`,
        method: "GET",
      }),
    }),

    addEducation: builder.mutation<ResponseTypeIndustriesDB, EducationType>({
      query: ({ param, data }) => ({
        url: `candidates/${param}/candidate-educations`,
        method: "POST",
        body: data,
      }),
    }),

    editEducation: builder.mutation<ResponseTypeIndustriesDB, EducationType>({
      query: ({ param, data }) => ({
        url: `candidateEducation/${param}`,
        method: "PATCH",
        body: data,
      }),
    }),

    addExperience: builder.mutation<ResponseTypeIndustriesDB, ExperienceType>({
      query: ({ param, data }) => ({
        url: `candidates/${param}/candidate-work-experiences`,
        method: "POST",
        body: data,
      }),
    }),

    editExperience: builder.mutation<ResponseTypeIndustriesDB, ExperienceType>({
      query: ({ param, data }) => ({
        url: `candidateWorkExperience/${param}`,
        method: "PATCH",
        body: data,
      }),
    }),
  }),
});

export const {
  useGetProfileDataFromDBMutation,
  useAddCertificateMutation,
  useEditCertificateMutation,
  useAddEducationMutation,
  useEditEducationMutation,
  useAddExperienceMutation,
  useEditExperienceMutation,
  useGetEducationsMutation,
} = profileApi;

// 'https://123.123.123.123/goods/121'
